export const InquiryEndpoints = {
    createInquiry: {
        method: "post",
        url: "/inquiries",
    },
    getAllInquiries: {
        method: "get",
        url: "/inquiries",
    },
    getInquiry: (id) => {
        return {
            method: "get",
            url: `/inquiries/${id}`,
        }
    },
    updateInquiry: {
        method: "put",
        url: "/inquiries/:id",
    },
    deleteInquiry: {
        method: "delete",
        url: "/inquiries/:id",
    },
}